export default [
  {
    position: "absolute",
    top: 22,
    left: 15,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    isAction: true,
    mTitle: "annualCompP2.mTitleOne",
    mBody: "annualCompP2.mBodyOne",
    id: "SP_AnnualCompensation_Action_ChartView",
    plusIcon: true,
    index: 0
  },
  {
    position: "absolute",
    top: 0.7,
    left: 0.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "annualCompP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_AnnualCompensation_Navigation_Menu",
    index: 1
  },
  {
    position: "absolute",
    top: 5.4,
    left: 13,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "annualCompP2.ttTextTwo",
    hover: false,
    id: "SP_AnnualCompensation_Navigation_Communications",
    index: 2
  },
  {
    position: "absolute",
    top: 5.4,
    left: 35.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "annualCompP2.ttTextSeven",
    hover: false,
    id: "SP_AnnualCompensation_Navigation_PayBenefits",
    index: 3
  },
  {
    position: "absolute",
    top: 5.4,
    left: 43.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "annualCompP2.ttTextThree",
    hover: false,
    id: "SP_AnnualCompensation_Navigation_Absence",
    index: 4
  },
  {
    position: "absolute",
    top: 5.4,
    left: 50.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "annualCompP2.ttTextFour",
    hover: false,
    id: "SP_AnnualCompensation_Navigation_Performance",
    index: 5
  },
  {
    position: "absolute",
    top: 5.4,
    left: 69.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "annualCompP2.ttTextFive",
    hover: false,
    id: "SP_AnnualCompensation_Navigation_Hiring",
    index: 6
  },
  {
    position: "absolute",
    top: 4.2,
    left: 98.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "annualCompP2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_AnnualCompensation_Navigation_TeamMember",
    index: 7
  },
];
